import {useCallback} from "react"
import {CONSTANTS} from "../constants/constants"
import type {CanvasSetupResult} from "../types/types"

export const useCanvasSetup = () => {
    const setupCanvases = useCallback(
        (
            mainCanvas: HTMLCanvasElement | null,
            cropWidth: number,
            cropHeight: number
        ): CanvasSetupResult | null => {
            if (!mainCanvas) return null

            const mainCtx = mainCanvas.getContext("2d")

            if (!mainCtx) return null

            mainCtx.imageSmoothingEnabled = true
            mainCtx.imageSmoothingQuality = "high"

            const dpr = window.devicePixelRatio || 1

            mainCanvas.width = CONSTANTS.CONTAINER_SIZE * dpr
            mainCanvas.height = CONSTANTS.CONTAINER_SIZE * dpr
            mainCanvas.style.width = `${CONSTANTS.CONTAINER_SIZE}px`
            mainCanvas.style.height = `${CONSTANTS.CONTAINER_SIZE}px`
            mainCtx.scale(dpr, dpr)

            mainCtx.clearRect(
                0,
                0,
                CONSTANTS.CONTAINER_SIZE,
                CONSTANTS.CONTAINER_SIZE
            )

            const cropScale = Math.min(
                CONSTANTS.CONTAINER_SIZE / cropWidth,
                CONSTANTS.CONTAINER_SIZE / cropHeight
            )
            const scaledCropWidth = cropWidth * cropScale
            const scaledCropHeight = cropHeight * cropScale
            const cropX = (CONSTANTS.CONTAINER_SIZE - scaledCropWidth) / 2
            const cropY = (CONSTANTS.CONTAINER_SIZE - scaledCropHeight) / 2
            return {
                mainCtx,
                dimensions: {
                    cropScale,
                    scaledCropWidth,
                    scaledCropHeight,
                    cropX,
                    cropY,
                },
            }
        },
        []
    )

    return {setupCanvases}
}
